import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { VerticalNestedItem } from "@/src/type/strapi/component/section/VerticaleNested";

import { DisplayItem } from "../DisplayItem";

interface AnimatedItemProps {
  item: VerticalNestedItem;
  onClick?: () => void;
  childItems?: VerticalNestedItem[];
  isOutline?: boolean;
  lazy?: "lazy" | "eager";
  quality?: number;
  isExpanded?: boolean;
  expandedItem?: string;
  boundingClientRect?: DOMRect;
}

function AnimatedItem({ item, isOutline, quality, childItems, boundingClientRect, isExpanded, onClick }: AnimatedItemProps) {
  const [addTransition, setAddTransition] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const [showText, setShowText] = useState(false);
  const [contentOn, setContentOn] = useState(false);
  const [show, setShow] = useState(false);

  function close() {
    setShowText(false);

    setTimeout(() => {
      setContentOn(false);
    }, 190);

    setTimeout(() => {
      setCanExpand(false);
    }, 200);

    setTimeout(() => {
      setAddTransition(false);
      setShow(false);

      if (onClick) {
        onClick();
      }
    }, 1200);
  }

  useEffect(() => {
    if (!isExpanded) {
      return;
    }
    setShow(true);

    setTimeout(() => {
      setAddTransition(true);
    }, 100);

    setTimeout(() => {
      setCanExpand(true);
    }, 400);

    setTimeout(() => {
      setContentOn(true);
      setShowText(true);
    }, 1200);
  }, [isExpanded]);

  useEffect(() => {
    if (!isExpanded && show) {
      close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded, show]);

  if (!show) {
    return <></>;
  }

  return ReactDOM.createPortal(
    <DisplayItem
      item={item}
      onClick={close}
      isExpanded={true}
      isOutline={isOutline}
      lazy="eager"
      quality={quality}
      childItems={childItems}
      animate={{ canExpand, showText, addTransition, contentOn }}
      boundingClientRect={boundingClientRect}
      fullLoad={true}
    />,
    document.body
  );
}

export default AnimatedItem;
